export default __webpack_public_path__ + "static/media/women-tech.00cd9647.png";